<template>
	<div class="image-slideshow">
		<!-- 顶部文字显示区域 -->
		<div class="caption-container">
			<transition name="fade" mode="out-in">
				<div class="caption" :key="currentIndex">
					<h2>{{ images[currentIndex].name }}</h2>
					<p>{{ images[currentIndex].description }}</p>
				</div>
			</transition>
		</div>

		<!-- 图片展示区域 -->
		<div class="slideshow-container">
			<transition name="slide" mode="out-in">
				<img :src="'https://digital-school-education.oss-cn-shanghai.aliyuncs.com/public/static/student_image/'+images[currentIndex].image_src" :alt="images[currentIndex].name" :key="currentIndex"
					class="slide-image">
			</transition>

			<!-- 导航按钮 -->
			<button class="prev" @click="prevSlide">❮</button>
			<button class="next" @click="nextSlide">❯</button>
		</div>

		<!-- 缩略图导航 -->
		<div class="thumbnail-container">
			<div v-for="(img, index) in visibleThumbnails" :key="index" class="thumbnail"
				:class="{ 'active': currentIndex === (startThumbnailIndex + index) }"
				@click="goToSlide(startThumbnailIndex + index)">
				<img :src="'https://digital-school-education.oss-cn-shanghai.aliyuncs.com/public/static/student_image/'+img.image_src" :alt="img.title">
			</div>
		</div>

		<!-- 控制面板 -->
		<div class="controls">
			<button @click="toggleAutoPlay">
				{{ autoPlay ? '⏸ 暂停' : '▶️ 播放' }}
			</button>
			<button @click="toggleFullscreen">
				{{ isFullscreen ? '退出全屏' : '全屏显示' }}
			</button>
			<div class="speed-control">
				<span>速度:</span>
				<button v-for="speed in speeds" :key="speed.value" :class="{ 'active': currentSpeed === speed.value }"
					@click="changeSpeed(speed.value)">
					{{ speed.label }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ImageSlideshow',
		data() {
			return {
				currentIndex: 0,
				autoPlay: true,
				interval: null,
				currentSpeed: 3000,
				isFullscreen: false,
				startThumbnailIndex: 0,
				speeds: [{
						label: '慢',
						value: 5000
					},
					{
						label: '中',
						value: 3000
					},
					{
						label: '快',
						value: 1000
					}
				],
				images: [],
			}
		},
		computed: {
			visibleThumbnails() {
				const thumbnailsPerPage = 10;
				return this.images.slice(
					this.startThumbnailIndex,
					Math.min(this.startThumbnailIndex + thumbnailsPerPage, this.images.length)
				);
			}
		},
		created() {
			this.service.get("/admin/admin/class2").then(respon => {
				this.images = respon.data
			}, err => {
				alert(err.message)
			})
		},
		methods: {
			nextSlide() {
				this.currentIndex = (this.currentIndex + 1) % this.images.length;
				this.updateThumbnailPosition();
			},
			prevSlide() {
				this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
				this.updateThumbnailPosition();
			},
			goToSlide(index) {
				this.currentIndex = index;
				this.updateThumbnailPosition();
			},
			updateThumbnailPosition() {
				const thumbnailsPerPage = 10;
				if (this.currentIndex >= this.startThumbnailIndex + thumbnailsPerPage) {
					this.startThumbnailIndex = Math.min(
						this.currentIndex - thumbnailsPerPage + 1,
						this.images.length - thumbnailsPerPage
					);
				} else if (this.currentIndex < this.startThumbnailIndex) {
					this.startThumbnailIndex = Math.max(0, this.currentIndex);
				}
			},
			startAutoPlay() {
				this.stopAutoPlay();
				this.interval = setInterval(() => {
					this.nextSlide();
				}, this.currentSpeed);
			},
			stopAutoPlay() {
				if (this.interval) {
					clearInterval(this.interval);
					this.interval = null;
				}
			},
			toggleAutoPlay() {
				this.autoPlay = !this.autoPlay;
				if (this.autoPlay) {
					this.startAutoPlay();
				} else {
					this.stopAutoPlay();
				}
			},
			changeSpeed(speed) {
				this.currentSpeed = speed;
				if (this.autoPlay) {
					this.startAutoPlay();
				}
			},
			toggleFullscreen() {
				if (!document.fullscreenElement) {
					this.$el.requestFullscreen().catch(err => {
						console.error(`全屏错误: ${err.message}`);
					});
					this.isFullscreen = true;
				} else {
					if (document.exitFullscreen) {
						document.exitFullscreen();
						this.isFullscreen = false;
					}
				}
			},
			handleFullscreenChange() {
				this.isFullscreen = !!document.fullscreenElement;
			}
		},
		mounted() {
			this.startAutoPlay();
			document.addEventListener('fullscreenchange', this.handleFullscreenChange);
		},
		beforeDestroy() {
			this.stopAutoPlay();
			document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
		}
	}
</script>

<style scoped>
	.image-slideshow {
		max-width: 1200px;
		margin: 0 auto;
		font-family: 'Arial', sans-serif;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
		border-radius: 10px;
		overflow: hidden;
		background-color: #fff;
	}

	.caption-container {
		background: linear-gradient(135deg, #3a7bd5 0%, #00d2ff 100%);
		color: white;
		padding: 20px;
		text-align: center;
		min-height: 120px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.caption h2 {
		margin-bottom: 10px;
		font-size: 24px;
	}

	.caption p {
		margin: 0;
		font-size: 16px;
		max-width: 800px;
		margin: 0 auto;
	}

	.slideshow-container {
		position: relative;
		height: 500px;
		overflow: hidden;
	}

	.slide-image {
		width: 100%;
		height: 100%;
		object-fit: contain;
		display: block;
	}

	.prev,
	.next {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		width: 50px;
		height: 50px;
		background-color: rgba(0, 0, 0, 0.5);
		color: white;
		border: none;
		border-radius: 50%;
		font-size: 20px;
		cursor: pointer;
		transition: all 0.3s;
	}

	.prev:hover,
	.next:hover {
		background-color: rgba(0, 0, 0, 0.8);
	}

	.prev {
		left: 20px;
	}

	.next {
		right: 20px;
	}

	.thumbnail-container {
		display: flex;
		overflow-x: auto;
		padding: 15px;
		background-color: #f5f5f5;
		scrollbar-width: none;
		/* Firefox */
	}

	.thumbnail-container::-webkit-scrollbar {
		display: none;
		/* Chrome/Safari */
	}

	.thumbnail {
		width: 80px;
		height: 60px;
		margin-right: 10px;
		cursor: pointer;
		border: 3px solid transparent;
		transition: all 0.3s;
		flex-shrink: 0;
	}

	.thumbnail:hover {
		transform: scale(1.05);
	}

	.thumbnail.active {
		border-color: #3a7bd5;
	}

	.thumbnail img {
		width: 100%;
		height: 100%;
		object-fit:contain;
	}

	.controls {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 15px;
		background-color: #f5f5f5;
		gap: 20px;
		flex-wrap: wrap;
	}

	.controls button {
		padding: 8px 16px;
		background-color: #3a7bd5;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s;
		font-size: 14px;
	}

	.controls button:hover {
		background-color: #2a5bb5;
	}

	.speed-control {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.speed-control button {
		padding: 5px 10px;
		background-color: #e0e0e0;
		color: #333;
	}

	.speed-control button.active {
		background-color: #3a7bd5;
		color: white;
	}

	/* 过渡动画 */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	.slide-enter-active {
		transition: all 0.5s ease;
	}

	.slide-leave-active {
		transition: all 0.5s ease;
	}

	.slide-enter {
		transform: translateX(100%);
		opacity: 0;
	}

	.slide-leave-to {
		transform: translateX(-100%);
		opacity: 0;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.slideshow-container {
			height: 300px;
		}

		.caption h2 {
			font-size: 20px;
		}

		.caption p {
			font-size: 14px;
		}

		.thumbnail {
			width: 60px;
			height: 45px;
		}

		.controls {
			flex-direction: column;
			gap: 10px;
		}
	}
</style>